module.exports = __webpack_public_path__ + "static/media/logo_animalcrossing_ja.68cd7909.svg";